import { HttpLink } from "@apollo/client";

export const httpLink = new HttpLink({
    headers: {},
    uri: `${process.env.API_URL}/bff/graphql`,
});
